export default {
  // Page title
  'page.title': 'Reloj Mundial',

  // Time zones and cities
  'timezone.utc': 'UTC',
  'timezone.local': 'Hora Local',
  'timezone.currentTime': 'Hora Actual',
  'timezone.label': 'Zona Horaria',
  'timezone.title': 'Zona Horaria de {{city}}',
  'timezone.localClockOffset': 'Diferencia Horaria Local',
  'timezone.timeZone': 'Zona horaria',
  'timezone.today': 'Hoy',
  'timezone.hours': 'H',
  'timezone.standardTimeZone': 'Zona Horaria Estándar',
  'timezone.daylightSavingTimeZone': 'Zona Horaria de Verano',

  // City names (keeping English as standard)
  'city.newYork': 'Nueva York',
  'city.london': 'Londres',
  'city.paris': 'París',
  'city.tokyo': 'Tokio',
  'city.sydney': 'Sídney',
  'city.dubai': 'Dubái',
  'city.singapore': 'Singapur',
  'city.hongKong': 'Hong Kong',
  'city.shanghai': 'Shanghái',
  'city.beijing': 'Pekín',
  'city.mumbai': 'Bombay',
  'city.moscow': 'Moscú',
  'city.berlin': 'Berlín',
  'city.losAngeles': 'Los Ángeles',
  'city.chicago': 'Chicago',
  'city.toronto': 'Toronto',
  'city.vancouver': 'Vancouver',
  'city.brasilia': 'Brasilia',
  'city.buenosAires': 'Buenos Aires',
  'city.cairo': 'El Cairo',
  'city.istanbul': 'Estambul',

  // How to use
  'howto.title': 'Cómo Usar el Reloj Mundial en Línea',
  'howto.step1': 'Este sitio web de reloj mundial muestra la hora actual y la hora mundial para cualquier ciudad del mundo. Consulta las zonas horarias, las diferencias de hora mundial y la hora internacional al instante en todo el globo.',
  'howto.step2': 'La página de inicio del reloj mundial muestra tu hora local más múltiples relojes mundiales de las principales ciudades. Cada zona horaria mundial muestra información precisa de hora, fecha y diferencia horaria.',
  'howto.step3': 'Haz clic en cualquier nombre de ciudad en la lista del reloj mundial para ver información detallada sobre la zona horaria. Cada página de hora mundial proporciona datos completos sobre la zona horaria y la hora actual de esa ubicación.',
  'howto.step4': 'Usa la búsqueda del reloj mundial para encontrar la hora en cualquier ciudad del mundo. Perfecto para consultar zonas horarias mundiales, coordinación de hora internacional y necesidades de gestión del tiempo global.',

  // User reviews
  'reviews.title': 'Opiniones de Usuarios',
  'reviews.globalBusiness': '¡Esencial para negocios internacionales! Fácil de coordinar horarios de reuniones entre diferentes zonas horarias, muy conveniente.',
  'reviews.travelBlogger': '¡Imprescindible para planificar viajes! Siempre conozco la hora local en mi destino, se acabó la confusión por el desfase horario.',
  'reviews.remoteTeam': '¡Perfecto para colaboración en equipo remoto! Fácil de ver cuándo los compañeros en diferentes países están trabajando.',
  'reviews.internationalFamily': '¡Genial para mantenerse conectado con la familia en el extranjero! Siempre sé el mejor momento para llamar sin interrumpir su sueño.',
  'reviews.managerZhang': 'Como gerente de proyectos, esto me ayuda a programar reuniones con clientes globales de manera más efectiva.',

  // User names
  'user.globalBusiness': 'Negocios Globales',
  'user.travelBlogger': 'Blogger de Viajes',
  'user.remoteTeam': 'Desarrollador Remoto',
  'user.internationalFamily': 'Familia Internacional',
  'user.managerZhang': 'Gerente Zhang',

  // Keywords
  'keywords.worldclock': 'reloj mundial zonas horarias hora internacional qué hora es',
  'keywords.chinese': '世界时钟 时区 国际时间 现在几点',
  'keywords.japanese': '世界時計 タイムゾーン 国際時間 今何時',
  'keywords.spanish': 'reloj mundial zonas horarias tiempo internacional qué hora',
  'keywords.german': 'Weltzeituhr Zeitzonen internationale Zeit wie spät',
  'keywords.french': 'horloge mondiale fuseaux horaires temps international quelle heure',
  'keywords.russian': 'мировые часы часовые пояса международное время который час',

  // Country related
  'countriesTime': 'Hora por País',
  'timeIn': 'Hora en',
  'cities': 'ciudades',
  'available': 'disponibles',
  'citiesIn': 'Ciudades en',
  'viewDetails': 'Ver detalles',
  'countryNotFound': 'País no encontrado',
  'backToWorldClock': 'Volver al Reloj Mundial',
  'cityNotFound': 'Ciudad no encontrada',
  'popularCitiesIn': 'Ciudades Populares en',
  'currentTime': 'Hora Actual',
};
